var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._g(_vm._b({class:{ 'is-selected': _vm.selected === _vm.value },on:{"click":function($event){return _vm.$emit('input', _vm.value)}}},'li',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label || _vm.value))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }